
function initializeEvents() {
	$('.video-carousel').slick({
		dots: true,
		infinite: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [
			{
			breakpoint: 480,
			settings: 'unslick'
			}
		]
	});
}

export default {
	init: function () {
		initializeEvents();
	}
};